import Vue from 'vue'
import VueRouter from 'vue-router'
import Router from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from '../views/login.vue'
import Register from '../views/register.vue'
import Publish from '../views/publish.vue'
import Advertisement from '../views/advertisement.vue'
import Consult from '../views/consult.vue'
import Digit from '../views/digit.vue'
import Platform from '../views/platform.vue'
import UserRecords from '../views/userRecords.vue'
import PlatformRecords from '../views/platformRecords.vue'
import ConsultRecords from '../views/consultRecords.vue'
import DigitRecords from '../views/digitRecords.vue'
import advertisementRecords from '@/views/advertisementRecords.vue'
import recordsDetail from '@/views/recordsDetail.vue'
import userDetail from '@/views/userDetail.vue'



import About from '../views/about.vue'
import Detail from '../views/detail.vue'
import Mine from '../views/mine.vue'
import Header from '../components/topHeader.vue'

Vue.use(VueRouter)
// 防止页面重复跳转
let originPush = Router.prototype.push;
Router.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    originPush.call(this, location, resolve, reject);
  } else {
    originPush.call(this, location, () => { }, () => { });
  }
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/',
    name: 'header',
    component: Header,
    redirect: "/",
    children: [
      {
        path: '',
        name: 'home',
        component: HomeView,
      },
      {
        path: 'publish',
        name: 'publish',
        component: Publish,
      },
      {
        path: 'advertisement',
        name: 'advertisement',
        component: Advertisement,
      },
      {
        path: 'consult',
        name: 'consult',
        component: Consult,
      },
      {
        path: 'digit',
        name: 'digit',
        component: Digit,
      },
      {
        path: 'platform',
        name: 'platform',
        component: Platform,
      },
      {
        path: 'about',
        name: 'about',
        component: About,
      },
      {
        path: 'detail',
        name: 'detail',
        component: Detail,
      },
      {
        path: 'mine',
        name: 'mine',
        component: Mine,
      },
      {
        path: 'userRecords',
        name: 'userRecords',
        component: UserRecords,
      },
      {
        path: 'platformRecords',
        name: 'platformRecords',
        component: PlatformRecords,
      },
      {
        path: 'consultRecords',
        name: 'consultRecords',
        component: ConsultRecords,
      },
      {
        path: 'digitRecords',
        name: 'digitRecords',
        component: DigitRecords,
      },
      {
        path: 'advertisementRecords',
        name: 'advertisementRecords',
        component: advertisementRecords,
      },
      {
        path: 'recordsDetail',
        name: 'recordsDetail',
        component: recordsDetail,
      },
      {
        path: 'userDetail',
        name: 'userDetail',
        component: userDetail,
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: "",
  routes
})

// 需要登录才能访问的路由
const requireAuthRoutes = [
  'mine',
  'userRecords',
  'platformRecords',
  'consultRecords',
  'digitRecords',
  'advertisementRecords',
  'recordsDetail'
];

// 全局前置守卫
router.beforeEach((to, from, next) => {
  try {
    // 检查是否需要登录
    const requiresAuth = requireAuthRoutes.some(route => to.path.includes(route));
    
    if (requiresAuth) {
      // 检查登录状态
      const loginStateStr = localStorage.getItem('loginstate');
      if (!loginStateStr) {
        // 没有登录状态，重定向到登录页面
        next({ path: '/login' });
        return;
      }
      
      try {
        const loginState = JSON.parse(loginStateStr);
        // 检查登录状态是否有效（这里可以根据实际情况添加更多检查，比如token是否过期）
        if (!loginState || !loginState.userName) {
          // 登录状态无效，重定向到登录页面
          localStorage.removeItem('loginstate');
          next({ path: '/login' });
          return;
        }
      } catch (error) {
        // 解析登录状态失败，重定向到登录页面
        localStorage.removeItem('loginstate');
        next({ path: '/login' });
        return;
      }
    }
    
    // 不需要登录或已登录，继续访问
    next();
  } catch (error) {
    console.error('路由守卫错误:', error);
    // 发生错误时，允许访问，避免页面卡死
    next();
  }
});

export default router
